const chalk = require('chalk')
const log = console.log

const { BASE_URL } = process.env

const logError = (err, ...args) => {
  log(`${chalk.white.bgRed(' ERROR ')} ${err}\n`, args.length ? args : '')
}

const logWarn = (warn, ...args) => {
  log(`${chalk.black.bgKeyword('orange')(' WARNING ')} ${warn}\n`, args.length ? args : '')
}

const logInfo = (info, ...args) => {
  log(`${chalk.white.bgBlue(' INFO ')} ${info}\n`, args.length ? args : '')
}

const logSuccess = (success, ...args) => {
  log(`${chalk.black.bgGreen(' SUCCESS ')} ${success}\n`, args.length ? args : '')
}

const makeRequestPath = (path, APIVersion = 'v1') => {
  return `${BASE_URL}?rest_route=/api/${APIVersion}/${path}`
}

const capitalizeFirst = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

const snakeToCamel = (string) => {
  return string.split('-').map(word => capitalizeFirst(word)).join('')
}

const camelToSnake = (string) => {
  return string.split(/(?=[A-Z])/).join('-').toLowerCase()
}

const camelToSpaced = (string) => {
  return string.split(/(?=[A-Z])/).join(' ')
}

module.exports = {
  logError,
  logWarn,
  logInfo,
  logSuccess,
  makeRequestPath,
  capitalizeFirst,
  snakeToCamel,
  camelToSnake,
  camelToSpaced
}
